"use strict";
/**
 * @license
 * Copyright 2020 Google Inc.
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PUPPETEER_REVISIONS = void 0;
/**
 * @internal
 */
exports.PUPPETEER_REVISIONS = Object.freeze({
    chrome: '135.0.7049.114',
    'chrome-headless-shell': '135.0.7049.114',
    firefox: 'stable_137.0.2',
});
//# sourceMappingURL=revisions.js.map